export function getSalonTimezone(currentSalon) {
  const fromStorage =
    typeof window !== "undefined" ? localStorage.getItem("salon_timezone") : null;
  return (
    currentSalon?.timezone ||
    currentSalon?.salon_timezone ||
    currentSalon?.salonTimezone ||
    fromStorage ||
    "America/New_York"
  );
}
